import { TemplateActionTypes } from "./template-types";

const INITIAL_STATE = {
  allTemplates: null,
  searchTemplatesQuery: {
    pageSize: 10,
    pageNumber: 1,
    sortDesc: false,
    sortBy: "Name",
    filters: [],
  },
  isFetchingTemplates: false,
  isFetchingAllTemplates: false,
  templates: [],
  templatesOnPage: null,
  numTemplates: 0,
  selectedTemplates: [],
};

const templateReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case TemplateActionTypes.FETCH_TEMPLATES_START:
      return {
        ...state,
        isFetchingTemplates: true,
      };

    case TemplateActionTypes.FETCH_TEMPLATES_SUCCESS:
      return {
        ...state,
        isFetchingTemplates: false,
        templates: action.payload[0],
        numTemplates: action.payload[1],
      };

    case TemplateActionTypes.FETCH_TEMPLATES_FAILURE:
      return {
        ...state,
        isFetchingTemplates: false,
        errorMessage: action.payload,
      };
    case TemplateActionTypes.SET_TEMPLATES_ON_PAGE: //setting the roles that are displayed on the page
      return {
        ...state,
        templatesOnPage: action.payload,
      };

    case TemplateActionTypes.SET_SEARCH_TEMPLATES_QUERY:
      return {
        ...state,
        searchTemplatesQuery: action.payload,
      };

    case TemplateActionTypes.ADD_SELECTED_TEMPLATE:
      return {
        ...state,
        selectedTemplates: [...state.selectedTemplates, action.payload],
      };

    case TemplateActionTypes.DELETE_SELECTED_TEMPLATE:
      return {
        ...state,
        selectedTemplates: [
          ...state.selectedTemplates.slice(
            0,
            state.selectedTemplates.indexOf(action.payload)
          ),
          ...state.selectedTemplates.slice(
            state.selectedTemplates.indexOf(action.payload) + 1
          ),
        ],
      };
    case TemplateActionTypes.SET_SELECTED_TEMPLATE:
      return {
        ...state,
        selectedTemplates: action.payload,
      };

    default:
      return state;
  }
};

export default templateReducer;
